




import {Component, Vue} from 'vue-property-decorator'
import env from '@/util/Env'

export interface State {
  q1: string | undefined
  pms: string | undefined
  backurl: string | undefined
}

@Component
export default class DiagnosisVue extends Vue {
  private state: State = {
    q1: undefined,
    pms: undefined,
    backurl: undefined,
  }
  private urlCondition: RegExp = new RegExp(env.ArrowedBackUrl)

  public created() {
    this.state.q1 = this.$route.query.q1 as string | undefined
    this.state.pms = this.$route.query.pms as string | undefined
    this.state.backurl = this.nomarizeBackUrl(this.$route.query.backurl as string | undefined)
  }

  public setState(newState: State) {
    this.state = Object.assign(this.state, newState)
  }

  private nomarizeBackUrl(url: string | undefined): string | undefined {
    if (!url) {
      return url
    }
    if (this.urlCondition.test(url)) {
      return url
    }
    return undefined
  }
}
